//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MtSwitch from "../form/MtSwitch";

export default {
  components: {
    MtSwitch
  },
  props:{
    fullName: {
      type: String,
      default: ''
    },
    picture:{
      type: String,
      default: ''
    },
    defaultAnonymous: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      anonymous: this.defaultAnonymous
    }
  },
  computed: {
  },
  watch: {
    anonymous: function() {
      this.$emit('changed', this.anonymous)
    }
  },
  methods: {
    pictureUrl (url) {
      if (this.anonymous || !url) {
        return "/app/images/default-male-avatar.svg"
      }
      return this.$absoluteImageUrl(url)
    }
  }
}
